module.exports = __webpack_public_path__ + "static/img/A (27).4860bc7b.png";